
      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire94c2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire94c2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

var $4AGbv = parcelRequire("4AGbv");
const $64033ce7d59ae4fb$var$coreLi = document.querySelectorAll(".pfa_item");
const $64033ce7d59ae4fb$var$img = document.querySelectorAll(".pfa_item img");
window.addEventListener("load", function() {
    (0, $4AGbv.default).set($64033ce7d59ae4fb$var$coreLi[0], {
        width: 596
    });
    (0, $4AGbv.default).set($64033ce7d59ae4fb$var$coreLi[1], {
        width: 293
    });
    (0, $4AGbv.default).set($64033ce7d59ae4fb$var$coreLi[2], {
        width: 293
    });
    (0, $4AGbv.default).set($64033ce7d59ae4fb$var$img[1], {
        x: -100
    });
    (0, $4AGbv.default).set($64033ce7d59ae4fb$var$img[2], {
        x: -300
    });
});
const $64033ce7d59ae4fb$var$tl = (0, $4AGbv.default).timeline({
    duration: 0.3
});
//监听鼠标移入移出事件
// const coreLi = document.querySelectorAll('.pfa_item');
$64033ce7d59ae4fb$var$coreLi.forEach((item, index)=>{
    item.addEventListener("mouseenter", function() {
        (0, $4AGbv.default).to([
            $64033ce7d59ae4fb$var$coreLi[0],
            $64033ce7d59ae4fb$var$coreLi[1],
            $64033ce7d59ae4fb$var$coreLi[2]
        ], {
            width: 293
        });
        (0, $4AGbv.default).to($64033ce7d59ae4fb$var$coreLi[index], {
            width: 596
        });
        if (index == 0) {
            (0, $4AGbv.default).to($64033ce7d59ae4fb$var$img[1], {
                x: -100
            });
            (0, $4AGbv.default).to($64033ce7d59ae4fb$var$img[2], {
                x: -300
            });
        }
        if (index == 1) {
            (0, $4AGbv.default).to($64033ce7d59ae4fb$var$img[2], {
                x: -300
            });
            (0, $4AGbv.default).to($64033ce7d59ae4fb$var$img[1], {
                x: 0
            });
        }
        if (index == 2) {
            (0, $4AGbv.default).to($64033ce7d59ae4fb$var$img[1], {
                x: -100
            });
            (0, $4AGbv.default).to($64033ce7d59ae4fb$var$img[2], {
                x: 0
            });
        }
    });
    item.addEventListener("mouseleave", function(event) {
        let index = event.target.getAttribute("data-id");
        $64033ce7d59ae4fb$var$coreLi.forEach((li, i)=>{
            if (li === this) (0, $4AGbv.default).to(li, {
                width: 596,
                duration: 0
            });
            else (0, $4AGbv.default).to(li, {
                width: 293,
                duration: 0
            });
        });
    // if(index == '1'){
    //     gsap.to(img[1],{
    //         x:-100,
    //         // duration:0.1,
    //      })
    // }
    // if(index == '2'){
    //     gsap.to(img[2],{
    //         x:-300,
    //         // duration:0.1,
    //      })
    // }
    });
});


//# sourceMappingURL=jlscp.5c557000.js.map
